import NewFeedRightSidebar from "components/app/new-feed-post/NewFeedRightSidebar";

export default function ExploreRightSideContent() {
  return (
    <div className="">
      <NewFeedRightSidebar />
    </div>
  );
}
